import { axiosInstance } from './common';

/**
 * Stored rule violations. The website no longer computes these — the server
 * evaluates on save and these endpoints read what it stored.
 */

export const getViolations = (dataCaptureId) =>
  axiosInstance.get(`/ruleengine/violations`, { params: { dataCaptureId } }).then((r) => r.data);

/** Batched, for the workspace. One request for many recordings, not one each. */
export const getViolationsBatch = (dataCaptureIds) => {
  if (!dataCaptureIds || dataCaptureIds.length === 0) return Promise.resolve([]);
  return axiosInstance
    .get(`/ruleengine/violations`, { params: { dataCaptureIds: dataCaptureIds.join(',') } })
    .then((r) => r.data);
};

export const reevaluate = (dataCaptureId) =>
  axiosInstance.post(`/ruleengine/${dataCaptureId}/evaluate`).then((r) => r.data);

/**
 * Parses an expression without saving it. Backs the formula editor, so it runs on
 * every debounced keystroke — it deliberately touches no database.
 */
export const validateExpression = (expression) =>
  axiosInstance.post(`/ruleengine/validate`, { expression }).then((r) => r.data);

export const getPresetPacks = () =>
  axiosInstance.get(`/rule/presets`).then((r) => r.data);

export const installPresetPack = (packId) =>
  axiosInstance.post(`/rule/presets/${packId}/install`).then((r) => r.data);
